<div *ngIf="!editMode && selectedStarRating">
  <span *ngIf="selectedStarRating.rank === 0">Not applicable</span>
  <div
    *ngIf="selectedStarRating.rank != 0"
    class="readonly-skills"
    [matTooltip]="getItemDescription(selectedStarRating)"
  >
    <app-star-rating
      class="evaluation-star-rating"
      [rating]="selectedStarRating.rank"
      [readOnly]="true"
    ></app-star-rating>
  </div>
</div>
<div *ngIf="editMode && starRatings.length" class="editable-skills-container">
  <div class="editable-skills" (mouseleave)="onMouseLeave()">
    <div
      class="level edit-mode na"
      [class.selected-na]="selectedStarRating && selectedStarRating.rank == 0"
      (click)="onStarRatingClickChange({ rating: 0 })"
      (mouseenter)="onStarRatingHoverChange({ rating: 0 })"
    >
      <mat-icon>not_interested</mat-icon>
    </div>
    <app-star-rating
      [rating]="getItemRank(selectedStarRating)"
      [hoverEnabled]="true"
      [staticColor]="getStaticColor(selectedStarRating)"
      (starClickChange)="onStarRatingClickChange($event)"
      (starHoverChange)="onStarRatingHoverChange($event)"
    ></app-star-rating>
  </div>
  <p class="star-rating-desc" *ngIf="hoveredStarRating">
    {{ getItemDescription(hoveredStarRating) }}
  </p>
  <p class="star-rating-desc" *ngIf="!hoveredStarRating && selectedStarRating">
    {{ getItemDescription(selectedStarRating) }}
  </p>
</div>
